import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { ThemeList } from 'store/ducks/globalTypes';
import { IThemeSelectorProps } from 'store/ducks/Global/types';
import * as Styled from './ThemeSelector.styled';

const ThemeSelector: React.FC<IThemeSelectorProps> = ({ children }) => {
  const { scheme } = useSelector((state: RootState) => state.global);

  return (
    <Styled.ThemeContainer theme={scheme as unknown as ThemeList}>
      {children}
    </Styled.ThemeContainer>
  );
};

export default ThemeSelector;
